import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { DomainAdd } from "@mui/icons-material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  BASE_URL,
  PPE_getApiSync,
  getValueFromLocalStorageFunc,
  notify,
} from "../../../services/functions";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

interface User {
  id: string;
  name: string;
}

const ModalAssignUser = (props) => {
  const { par_show, status, row, outChange } = props;
  const { id } = useParams();
  const [show, setShow] = useState(false);
  const [objValueInput, setObjValueInput] = useState({
    id_member: id ?? "", // Directly use id from URL
    id_user: "",
  });
  const [usersList, setUsersList] = useState<User[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const refEmailInput = useRef<HTMLInputElement | null>(null);

  console.log("Data USer", usersList);
  useEffect(() => {
    setShow(par_show ?? false);

    // Directly use idMember from params for the member name field
    setObjValueInput((prevState) => ({
      ...prevState,
      id_member: id ?? "", // Assign id_member directly from URL param
    }));

    const usersEndpoint = `${BASE_URL}/v1/users/list?limit=1000&offset=0`; // Endpoint for users list
    PPE_getApiSync(
      usersEndpoint,
      null,
      "application/json",
      "GET",
      getValueFromLocalStorageFunc("IOT_TOKEN"),
    )
      .then((response) => {
        setUsersList(response); // Set the fetched users
        setIsLoading(false); // Set loading to false when data is fetched
      })
      .catch((error) => {
        console.error(error);
        notify("error", "Failed to fetch users list", "TOP_CENTER");
        setIsLoading(false); // Set loading to false on error
      });

    setTimeout(() => {
      if (refEmailInput.current) {
        refEmailInput.current.focus();
        refEmailInput.current.select();
      }
    }, 100);
  }, [par_show, status, row, id]);

  const handleHide = () => {
    setShow(false);
    outChange(false);
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleChangeInput = (
    event: React.ChangeEvent<HTMLInputElement>,
    tipeInput: string,
  ) => {
    setObjValueInput((obj) => ({
      ...obj,
      [tipeInput]: event.target.value,
    }));
  };

  // Explicitly typing the event for the select element
  const handleChangeUser = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setObjValueInput((obj) => ({
      ...obj,
      id_user: event.target.value,
    }));
  };

  // const handleSubmit = () => {
  //   const token = getValueFromLocalStorageFunc("IOT_TOKEN") ?? "";
  //   const methodhit = status === "Create" ? "POST" : "PUT";
  //   const endpoint =
  //     status === "Create"
  //       ? `${BASE_URL}/v1/members/addUser`
  //       : `${BASE_URL}/v1/members/${row?.id}`;

  //   const objSubmitToAPI = {
  //     id_member: objValueInput.id_member,
  //     // id_user: objValueInput.id_user,
  //     id_users: [parseInt(objValueInput.id_user)],
  //   };

  //   console.log("ID Member:", typeof objSubmitToAPI.id_member);
  //   console.log("[CreateListMembers] objValueInput", objValueInput);
  //   console.log("Submit Data Member:", objSubmitToAPI);

  //   PPE_getApiSync(
  //     endpoint,
  //     objSubmitToAPI,
  //     "application/json",
  //     methodhit,
  //     token
  //   )
  //     .then((response) => {
  //       const statusCodeError = response?.statusCode;

  //       if (statusCodeError) {
  //         notify("error", response?.msg, "TOP_CENTER");
  //         return;
  //       }

  //       const successMessage =
  //         response?.results?.join(", ") || "User(s) added successfully";
  //       notify("success", successMessage, "TOP_CENTER");

  //       setShow(false);
  //       outChange({
  //         tipe: "close_after_success_save",
  //         value: false,
  //         form: "create",
  //       });
  //     })
  //     .catch((error) => {
  //       notify(
  //         "error",
  //         "An error occurred. Please try again later.",
  //         "TOP_CENTER"
  //       );
  //     });
  // };

  const handleSubmit = () => {
    const token = getValueFromLocalStorageFunc("IOT_TOKEN") ?? "";
    const methodhit = status === "Create" ? "POST" : "PUT";
    const endpoint =
      status === "Create"
        ? `${BASE_URL}/v1/members/addUser`
        : `${BASE_URL}/v1/members/${row?.id}`;

    // Update request body to send id_users as an array
    const objSubmitToAPI = {
      id_member: objValueInput.id_member,
      id_users: [parseInt(objValueInput.id_user)], // Wrap the id_user in an array
    };

    console.log("Submit Data Member:", objSubmitToAPI);

    PPE_getApiSync(
      endpoint,
      objSubmitToAPI,
      "application/json",
      methodhit,
      token,
    )
      .then((response) => {
        console.log("API Response:", response); // Log the full response to debug

        const { detail, errors, results } = response || {};

        // Handle "Failed to add any users" in the detail
        if (detail) {
          if (detail.includes("Failed to add any users")) {
            console.log("Error: " + detail);
            notify("error", detail, "TOP_CENTER");
          } else if (detail.includes("Some users added successfully")) {
            console.log("Warning: " + detail);
            notify("warning", detail, "TOP_CENTER");
          }
        }

        // Handle errors (e.g., user already exists)
        if (errors && errors.length > 0) {
          console.log("Errors: " + errors.join(", "));
          notify("error", errors.join(", "), "TOP_CENTER");
        }

        // Handle success case: check if results exist and notify accordingly
        if (results && results.length > 0) {
          console.log("Success Results: " + results.join(", "));
          const successMessage = results.join(", ");
          notify("success", successMessage, "TOP_CENTER");
        } else {
          // Fallback if no results and no errors are present
          console.log("Success: No results found but no errors.");
          notify("success", "User(s) added successfully", "TOP_CENTER");
        }

        // Closing the modal and handling state change
        setShow(false);
        outChange({
          tipe: "close_after_success_save",
          value: false,
          form: "create",
        });
      })
      .catch((error) => {
        console.error("Error occurred:", error);
        notify(
          "error",
          "An error occurred. Please try again later.",
          "TOP_CENTER",
        );
      });
  };

  return (
    <>
      <Modal show={show} centered size="sm" backdrop={true} onHide={handleHide}>
        <Modal.Header
          className={`modalheader modal-header-global ${
            status === "Edit" ? "edit" : "create"
          }`}
        >
          <Modal.Title className={`dashboard-modal-title`}>
            {status === "Create" && (
              <>
                <DomainAdd
                  style={{
                    position: "absolute",
                    right: 15,
                    top: 25,
                    zIndex: 0,
                    transform: "scale(1.5)",
                  }}
                  className={`login-dropdown-icon`}
                />
                <FontAwesomeIcon
                  icon={faPlus}
                  className={`login-dropdown-icon`}
                  color={"darkgreen"}
                  style={{
                    position: "absolute",
                    right: 0,
                    top: 10,
                    zIndex: 0,
                    transform: "scale(1.5)",
                  }}
                />
              </>
            )}
            <span className="login-icon-modal-title">Add User</span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div style={{ display: "flex" }} className="row">
            <Form.Group className="mb-1 col-12" controlId="id-member">
              <Form.Label className="mb-1 dash-modal-form-label required">
                Member ID
              </Form.Label>
              <Form.Control
                type="text"
                className="modal-input-placeholder"
                placeholder="Enter Member Name"
                maxLength={100}
                ref={refEmailInput}
                value={objValueInput.id_member}
                disabled // Disabled so user can't edit this field
              />
            </Form.Group>

            {/* <Form.Group className="mb-1 col-12" controlId="id-user">
              <Form.Label className="mb-1 dash-modal-form-label required">
                Username
              </Form.Label>

              <Form.Select
                className="form-control"
                value={objValueInput.id_user}
                onChange={handleChangeUser}
                disabled={isLoading}
              >
                <option value="">Select User</option>
                {isLoading ? (
                  <option>Loading...</option>
                ) : usersList.length === 0 ? (
                  <option>No users available</option>
                ) : (
                  usersList.map((user) => (
                    <option key={user.id} value={user.id}>
                      {user.name}
                    </option>
                  ))
                )}
              </Form.Select>
            </Form.Group> */}
            <Form.Group className="mb-1 col-12" controlId="id-user">
              <Form.Label className="mb-1 dash-modal-form-label required">
                Username
              </Form.Label>
              <Form.Select
                className="form-control"
                value={objValueInput.id_user}
                onChange={handleChangeUser}
                disabled={isLoading}
              >
                <option value="">Select User</option>
                {isLoading ? (
                  <option>Loading...</option>
                ) : usersList.length === 0 ? (
                  <option>No users available</option>
                ) : (
                  usersList.map((user) => (
                    <option key={user.id} value={user.id}>
                      {user.name}
                    </option>
                  ))
                )}
              </Form.Select>
            </Form.Group>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleSubmit()}>
            Save
          </Button>
          <Button variant="secondary" onClick={() => handleHide()}>
            Close
          </Button>
        </Modal.Footer>

        <ToastContainer draggable pauseOnHover />
      </Modal>
    </>
  );
};

export default ModalAssignUser;
